import { httpRequest } from "@/lib";

export interface BeforeAfterCase {
  id: string;
  tenant_id: string;
  patient_id: string;
  procedure: string;
  before_image_url: string;
  after_image_url: string;
  before_image_full_url?: string;
  after_image_full_url?: string;
  context?: string;
  analysis_available?: boolean;
  analysis_unavailable_reason?: string;
  analysis_status: "not_requested" | "processing" | "completed" | "failed";
  analysis?: {
    analysis_summary?: string;
    metrics?: {
      symmetry_score_before?: number;
      symmetry_score_after?: number;
      skin_texture_improvement?: string;
      volume_restoration?: string;
    };
    pdf_url?: string;
    comparison_image_url?: string;
  };
  tags?: string[];
  is_published: boolean;
  analyzed_at?: string;
  created_at: string;
  patient?: { id: string; name: string; person?: { name?: string } };
}

export async function fetchGallery(params?: {
  procedure?: string;
  patient_id?: string;
  is_published?: boolean;
}): Promise<BeforeAfterCase[]> {
  const query = new URLSearchParams();
  if (params?.procedure) query.set("procedure", params.procedure);
  if (params?.patient_id) query.set("patient_id", params.patient_id);
  if (params?.is_published !== undefined) query.set("is_published", String(params.is_published));
  const qs = query.toString();
  const res = await httpRequest.get(`/gallery${qs ? `?${qs}` : ""}`);
  return res.data?.data ?? res.data ?? [];
}

export async function uploadCase(data: FormData): Promise<BeforeAfterCase> {
  const res = await httpRequest.post("/gallery", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function analyzeCase(id: string): Promise<BeforeAfterCase> {
  const res = await httpRequest.post(`/gallery/${id}/analyze`);
  return res.data?.data ?? res.data;
}

export async function togglePublish(id: string): Promise<BeforeAfterCase> {
  const res = await httpRequest.patch(`/gallery/${id}/publish`);
  return res.data;
}

export async function deleteCase(id: string): Promise<void> {
  await httpRequest.delete(`/gallery/${id}`);
}
